import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/license/aares_upload";

export class UploadAuthActionCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    newFormData: FormData = new FormData();

    constructor(files: any) {
        super();
        this.newFormData = new FormData();
        for (var i = 0; i < files.length; i++) {
            let file = files[i];
            this.newFormData.append("files[" + i + "]", file, file.name);
        }
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.newFormData, { "Content-Type": "multipart/form-data" });
    }
}
